import React from 'react';
import site from '../../data/site';

const TopBar = () => (
    <div className="sw-topbar">
        <span className="sw-topbar__info">{site.officeHoursShort} · {site.location}</span>
        <a className="sw-topbar__call" href={site.phones[0].href}>Call {site.phones[0].label}</a>
    </div>
);

export default TopBar;
